module.exports = __webpack_public_path__ + "img/cjr-icon.cbb625ab.png";